// Shared constants for the bulletin board ("Nástěnka").
// The virtual board coordinate space must match the backend clamp in StickyNoteServiceImpl.

export const BOARD_WIDTH = 4000;
export const BOARD_HEIGHT = 2500;

/** Rendered note size in board units. */
export const NOTE_WIDTH = 220;
/** Height of the note header (pin + author name) above the square drawing. */
export const NOTE_HEADER_HEIGHT = 48;
export const NOTE_HEIGHT = NOTE_WIDTH + NOTE_HEADER_HEIGHT;

export interface PaperColor {
  key: string;
  base: string;
  edge: string;
}

export const PAPER_COLORS: PaperColor[] = [
  { key: "yellow", base: "#feef9c", edge: "#f2d977" },
  { key: "pink", base: "#ffc9dd", edge: "#f7a3c4" },
  { key: "blue", base: "#bfe1fe", edge: "#93c8f1" },
  { key: "green", base: "#c9f0bd", edge: "#a2df92" },
  { key: "orange", base: "#ffd7a6", edge: "#fdbb75" },
  { key: "purple", base: "#e2c5fc", edge: "#c9a2f6" },
  { key: "mint", base: "#c2f5e8", edge: "#94e2cd" },
  { key: "white", base: "#f8f9fa", edge: "#dfe0e2" },
];

export const paperColorByKey = (key: string): PaperColor =>
  PAPER_COLORS.find((c) => c.key === key) ?? PAPER_COLORS[0];

export interface PinColor {
  key: string;
  color: string;
}

export const PIN_COLORS: PinColor[] = [
  { key: "red", color: "#e63946" },
  { key: "blue", color: "#3a6ea8" },
  { key: "green", color: "#2a9d4a" },
  { key: "yellow", color: "#f4b400" },
  { key: "purple", color: "#8338ec" },
  { key: "black", color: "#343a40" },
];

export const pinColorByKey = (key: string): PinColor =>
  PIN_COLORS.find((c) => c.key === key) ?? PIN_COLORS[0];

export const PEN_COLORS = [
  "#212529",
  "#e63946",
  "#1d6fb8",
  "#2a9d4a",
  "#f77f00",
  "#8338ec",
  "#d81b8c",
  "#6f4e37",
  "#12958a",
  "#f4b400",
  "#8d99ae",
  "#ffffff",
];

export const NOTE_EMOJIS = [
  "😀", "😂", "😍", "😎", "🤔", "😭", "🔥", "❤️", "👍", "👎",
  "🎉", "🏆", "🏓", "⭐", "💪", "🍺", "☕", "💩", "🚀", "🤡",
];

export interface NoteFont {
  key: string;
  css: string;
}

export const NOTE_FONTS: NoteFont[] = [
  { key: "hand", css: "'Segoe Print', 'Comic Sans MS', cursive" },
  { key: "clean", css: "'Segoe UI', 'Helvetica Neue', sans-serif" },
  { key: "typewriter", css: "'Courier New', monospace" },
];

/** Must stay below the backend MAX_IMAGE_DATA_LENGTH (600 000 chars). */
export const MAX_IMAGE_DATA_LENGTH = 600_000;
